// Web-only strings for the compose feature (keys prefixed `web.compose.`), BOTH languages. Apple
// keys are used wherever they exist (forward.*, channel.priority.*, channel.ephemeral.*); these
// are the gaps: the web's extra forward tiers and its after-send toast, the command/channel strip
// labels, and the goto/err texts a browser needs.
export const strings: { es: Record<string, string> ; en: Record<string, string> } = {
  es: {
    'web.compose.forward.recent': 'Recientes',
    'web.compose.forward.people': 'Personas',
    'web.compose.forward.preview': 'Mensaje que reenvías',
    'web.compose.forward.sent': 'Mensaje reenviado a %@',
    'web.compose.forward.go': 'Ir a la conversación',
    'web.message.forwarded': 'Reenviado',
    'web.compose.forward.failed': 'No se pudo reenviar el mensaje.',
    'web.compose.forward.directMessage': 'Mensaje directo',
    'web.compose.forward.attachmentOnly': 'Mensaje con archivos adjuntos',
    'web.compose.command.failed': 'No se pudo ejecutar el comando.',
    'web.compose.command.running': 'Ejecutando %@…',
    'web.compose.channels.other': 'Otros canales',
    'web.compose.channel.notFound': 'No encontré el canal ~%@.',
    'web.compose.priority.clear': 'Quitar prioridad',
    'web.compose.editLast.none': 'No tienes mensajes que editar aquí.',
  },
  en: {
    'web.compose.forward.recent': 'Recent',
    'web.compose.forward.people': 'People',
    'web.compose.forward.preview': 'Message you are forwarding',
    'web.compose.forward.sent': 'Message forwarded to %@',
    'web.compose.forward.go': 'Go to the conversation',
    'web.message.forwarded': 'Forwarded',
    'web.compose.forward.failed': 'The message could not be forwarded.',
    'web.compose.forward.directMessage': 'Direct message',
    'web.compose.forward.attachmentOnly': 'Message with attachments',
    'web.compose.command.failed': 'The command could not be run.',
    'web.compose.command.running': 'Running %@…',
    'web.compose.channels.other': 'Other channels',
    'web.compose.channel.notFound': 'Channel ~%@ was not found.',
    'web.compose.priority.clear': 'Clear priority',
    'web.compose.editLast.none': 'You have no messages to edit here.',
  },
};
